import { itemTypes, bannerStates } from '@constants/index';
import {
  isTopicFeed,
  isCourseFeedBlock,
  isEducatorBlock,
  isBatchBlock,
  isBannerBlock
} from '@utils/feedTypeHelper';

const getUid = (data) => {
  let uid = data.type || data.block_type;
  if (data.key) uid += `_${data.key}`;
  if (data.extra_block_info) {
    if (data.extra_block_info.id) uid += `_${data.extra_block_info.id}`;
    if (data.extra_block_info.uid) uid += `_${data.extra_block_info.uid}`;
    if (data.extra_block_info.title)
      uid += `_${data.extra_block_info.title.split(' ').join('_')}`;
  }
  return uid;
};

class Feedrow {
  constructor(feedrow) {
    this.key = feedrow.key || '';
    this.type = feedrow.type || feedrow.block_type;
    this.extraBlockinfo = feedrow.extra_block_info;
    this.coursesCount = feedrow.courses_count;
    if (this.coursesCount) this.extraBlockinfo.coursesCount = this.coursesCount;
    this.uid = getUid(feedrow);
    this.label =
      feedrow.label ||
      feedrow.title ||
      feedrow.extra_block_info?.label ||
      feedrow.extra_block_info?.title ||
      feedrow.extra_block_info?.name ||
      feedrow.extra_block_info?.entity_type;
    this.data = feedrow.data;
    const id = feedrow.extra_block_info
      ? feedrow.extra_block_info.id?.toLowerCase()
      : '';
    if (isCourseFeedBlock(feedrow.extra_block_info.entity_type)) {
      this.courses = feedrow.data
        .map((courseData) => {
          if (courseData.type === itemTypes.POST)
            return { item: courseData.data };
          if (!courseData.batch_template)
            return { course: courseData.data || courseData };
          return null;
        })
        .filter((obj) => obj);
      this.batches = feedrow.data
        .map((batchData) =>
          batchData.batch_template ? { batch: batchData } : null
        )
        .filter((obj) => obj);
    } else if (isEducatorBlock(feedrow.extra_block_info.entity_type))
      this.users = feedrow.data.map((educatorData) => ({ user: educatorData }));
    else if (isTopicFeed(id))
      this.topologies = feedrow.data.map((topologyData) => ({
        topology: topologyData
      }));
    else if (this.type === 'dym')
      this.suggestions = feedrow.data.map(
        (suggestion) => suggestion.suggestion
      );
    else if (this.type === 'related_searches')
      this.relatedSearches = feedrow.data.map((query) => query.query);
    else if (isBatchBlock(feedrow.extra_block_info.entity_type))
      this.batches = feedrow.data.map((batchData) => ({ batch: batchData }));
    else if (isBannerBlock(this.type))
      this.carouselFeed = feedrow.data.map((data) => {
        const bannerDetails = {
          uid: data.uid,
          title: data.title,
          description: data.description,
          type: data.banner_type,
          bannerPhoto: data.banner_photo,
          clickURL: data.click_url
        };
        if (data.banner_type === bannerStates.ITEM)
          return {
            course: data.session_info.course_info,
            sessionData: data.session_info,
            bannerDetails
          };
        if (
          [
            bannerStates.LEGENDS,
            bannerStates.TEST_SERIES,
            bannerStates.GENERIC,
            bannerStates.COMBAT,
            bannerStates.RENEWAL
          ].includes(data.banner_type)
        )
          return {
            course: data.session_info,
            sessionData: data.session_info,
            bannerDetails
          };
        return data;
      });
    if (feedrow.topology) this.topology = feedrow.topology;
  }
}

const getEntityData = (data) => new Feedrow(data);

export default { Feedrow, getEntityData, getUid };
